module.exports = __webpack_public_path__ + "img/facebook-2.676507bf.svg";